<template>
  <div class="main-wrapper aboutus-page">
    <layouts-header v-if="!authStore.user"></layouts-header>
    <user-header v-if="authStore.user"></user-header>
    <breadcrumb :title="title" :text="text" :text1="text1" />
    <div class="content">
      <!-- About Us Info -->
      <about-vision></about-vision>
      <!-- /About Us Info -->

      <about-team></about-team>

      <!-- Group Coaching -->
    </div>
  </div>
  <layout-footer></layout-footer>
</template>
<script>
import { useAuthStore } from "@/stores/auth";

export default {
  data() {
    const authStore = useAuthStore();

    return {
      authStore,
      title: "Về chúng tôi",
      text: "Trang chủ",
      text1: "Về chúng tôi",
    };
  },
};
</script>
